import { useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import cls from 'classnames';
import { getAllCategories } from '../../../api/carteleriaApi';
import CategoryRow from '../../common/CategoryRow';
import useClickOutside from '../../../hooks/useClickOutside';

const FilterMenuExcel = ({
  search,
  statusSelected,
  centerTypeSelected,
  centerSelected,
  superIdCategory,
  setSuperIdCategory,
  categorySelected,
  setCategorySelected,
  withoutCategorySelected,
  setWithoutCategorySelected,
}) => {
  const menuRef = useRef(null);
  const { getAccessTokenSilently } = useAuth0();
  const [currentOption, setCurrentOption] = useState(null);

  const { data: allCategoriesParent } = useQuery(
    [
      'allCategoriesParent-excel',
      {
        idParentCategory: superIdCategory?._id,
        statusSelected,
        centerTypeSelected,
        centerSelected: centerSelected?._id,
        search,
      },
    ],
    async () => {
      const token = await getAccessTokenSilently();
      return await getAllCategories(token, {
        idParentCategory: superIdCategory?._id,
        statusSelected,
        idCenterType: centerTypeSelected,
        centerSelected: centerSelected?._id
          ? {
              comunidad: centerSelected.comunidad,
              centerType: centerSelected.centerType,
              imagenAnterior: centerSelected.imagenAnterior,
              imagenNueva: centerSelected.imagenNueva,
            }
          : null,
        inputValueSearch: search,
        panelMaster: true,
      });
    },
  );

  const categoriesRef = useClickOutside(() => setCurrentOption(null), [menuRef]);

  const handleToggleSidebar = (e) => {
    e.stopPropagation();
    setCurrentOption((prev) => (prev === 'categories' ? null : 'categories'));
  };

  const handleBackCategory = () => {
    if (categorySelected.length > 1) {
      const newCategorySelected = categorySelected.slice(0, categorySelected.length - 1);
      setCategorySelected(newCategorySelected);
      setSuperIdCategory({
        _id: newCategorySelected[newCategorySelected.length - 1]._id,
        parentCategory: newCategorySelected[newCategorySelected.length - 1].parentCategory,
      });
    } else {
      setCategorySelected([]);
      setSuperIdCategory(null);
    }
  };

  const handleCategory = (category) => {
    const isCategorySelected = categorySelected.some((selected) => selected._id === category._id);
    if (!isCategorySelected) {
      setCategorySelected([...categorySelected, category]);
    }
  };

  const handleCategoryClick = (category) => {
    if (superIdCategory?._id === category._id) {
      setSuperIdCategory(null);
      setCategorySelected([]);
    } else {
      setCategorySelected([category]);
      setSuperIdCategory({
        _id: category._id,
        parentCategory: category.parentCategory,
      });
      handleCategory(category);
    }
  };

  const handleWithoutCategoryClick = () => {
    const newValue = !withoutCategorySelected;

    setWithoutCategorySelected(newValue);

    if (!withoutCategorySelected) {
      setCategorySelected([]);
      setSuperIdCategory(null);
    }
  };

  const containerCategoriesClass = cls({
    'container-categories': true,
    'test-animation': currentOption === 'categories',
  });

  return (
    <div className="container-filter-menu-master">
      <div className={`sidebar-container ${currentOption ? 'sidebar-container__open' : ''}`}>
        <div style={{ position: 'relative', display: 'inline-flex' }}>
          <MenuIcon
            ref={menuRef}
            fontSize="large"
            className={`icon-sidebar-arte-final ${
              currentOption === 'categories' ? 'icon-sidebar-arte-final__selected' : ''
            }`}
            onClick={(e) => {
              e.stopPropagation();
              handleToggleSidebar(e);
            }}
          />
          {categorySelected?.length > 0 && (
            <span
              style={{
                position: 'absolute',
                top: -6,
                right: -8,
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: '#e53935',
                pointerEvents: 'none',
              }}
            />
          )}
        </div>
      </div>
      <div ref={categoriesRef} className={containerCategoriesClass}>
        <div className="container-arrow-title">
          {categorySelected?.length > 0 && <ArrowBackIcon onClick={handleBackCategory} className="pointer" />}
          <Typography className="title-master-articulos-filter-category">MENÚ</Typography>
        </div>
        <div>
          {allCategoriesParent?.data && (
            <div className="category-list">
              <ul style={{ listStyleType: 'none', padding: '1rem 0 0 0.5rem' }}>
                {allCategoriesParent?.data?.length === 0 ? (
                  <span className="not-more-subcategories">No hay más submenús para filtrar</span>
                ) : (
                  allCategoriesParent?.data.map((category) => (
                    <CategoryRow key={category._id} category={category} handleCategoryClick={handleCategoryClick} />
                  ))
                )}
              </ul>

              {categorySelected.length === 0 && (
                <div className="without-category-container">
                  <div
                    className={`without-category-row ${withoutCategorySelected ? 'category-selected' : ''}`}
                    onClick={handleWithoutCategoryClick}
                  >
                    <i>Sin categoría</i>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterMenuExcel;
